import { createGlobalStyle } from "styled-components";

import ywftUltramagneticSrc from "../fonts/YWFTUltramagnetic.woff";
import rockwellSrc from "../fonts/rockwell.woff2";

import gothamLightSrc from "../fonts/gotham-light.woff2";
import gothamBookSrc from "../fonts/gotham-book.woff2";
import gothamMediumSrc from "../fonts/gotham-medium.woff2";
import gothamBoldSrc from "../fonts/gotham-bold.woff2";
import gothamBlackSrc from "../fonts/gotham-black.woff2";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 300;
    src: url(${gothamLightSrc}) format('woff');
  }

  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 400;
    src: url(${gothamBookSrc}) format('woff');
  }

  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 500;
    src: url(${gothamMediumSrc}) format('woff');
  }

  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 700;
    src: url(${gothamBoldSrc}) format('woff');
  }

  @font-face {
    font-family: 'Gotham';
    font-style: normal;
    font-weight: 900;
    src: url(${gothamBlackSrc}) format('woff');
  }

  @font-face {
    font-family: 'YWFT Ultramagnetic';
    font-style: normal;
    font-weight: 400;
    src: url(${ywftUltramagneticSrc}) format('woff');
  }

  @font-face {
    font-family: 'Rockwell';
    font-style: normal;
    font-weight: 400;
    src: url(${rockwellSrc}) format('woff2');
  }

  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html,
  body {
    min-height: 100vh;
  }

  body {
    min-width: 375px;
    margin: 0;
    color: #fff;
    background-color: #171717;
    font-family: 'Gotham';
  }

  #___gatsby {
    min-height: 100vh;
  }

  #gatsby-focus-wrapper {
    min-height: 100vh;
  }

  button {
    color: inherit;
    background-color: transparent;
    background-image: none;
    font-family: inherit;
    letter-spacing: inherit;
    border: 0 none;
    outline: none;
    cursor: pointer;
  }

  img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .grecaptcha-badge {
    z-index: 9999;
  }
`;

export default GlobalStyle;
